package com.essntl.features.itinerary.domain.use_case

import com.essntl.core.utils.utils.capitalizeFirstLetter
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceOrderType
import core.dateformat.utils.formatTimestampToHHMM
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalTime

object SortItineraryServices {
    operator fun invoke(
        itineraryServices: List<ItineraryServiceModel>?,
        itineraries: List<ItineraryModel>? = null,
        clients: List<ClientModel>? = null,
        filterOptions: ItineraryServiceFilterOptions,
    ): List<ItineraryServiceModel> {
        val sortedServices = itineraryServices
            .orEmpty()
            .sortedWith(
                when (filterOptions.selectedItineraryServiceOrderType) {
                    ItineraryServiceOrderType.StartDate -> compareBy { it.startDate.let { date -> LocalDate.parse(date) } }

                    ItineraryServiceOrderType.StartTime -> compareBy {
                        it.startTime?.let { time ->
                            LocalTime.parse(
                                formatTimestampToHHMM(time),
                            )
                        }
                    }

                    ItineraryServiceOrderType.Status -> compareBy { it.status?.name }

                    ItineraryServiceOrderType.Client -> compareBy(
                        {
                            val proposal = itineraries?.find { itinerary -> itinerary.id == it.itineraryId }?.proposal
                            val client = clients?.find { client -> client.id == proposal?.primaryClient?.id }
                            client?.prettyName?.capitalizeFirstLetter()
                        },
                        { it.startDate.let { date -> LocalDate.parse(date) } },
                        { it.startTime?.let { time -> LocalTime.parse(formatTimestampToHHMM(time)) } },
                    )

                    ItineraryServiceOrderType.StartDateStartTime -> compareBy(
                        { it.startDate.let { date -> LocalDate.parse(date) } },
                        { it.startTime?.let { time -> LocalTime.parse(formatTimestampToHHMM(time)) } },
                    )
                },
            )

        return sortedServices.partition { it.status != ItineraryServiceModel.Status.Cancelled }
            .let { (nonCancelled, cancelled) -> nonCancelled + cancelled }
    }
}
